// FulfillmentOrderReducer.js
//
// Order Fulfillment module (Phase 2A). Registered in rootReducer.js as
// `fulfillmentOrders` — NewFulfillmentOrder.jsx and MyFulfillmentOrders.jsx
// both read `state.fulfillmentOrders`.

const initialState = {
  orders: [],
  pagination: null,
  selectedOrder: null,
  summary: null, // Phase 2B admin dashboard cards
  loading: false, // list/detail fetch
  summaryLoading: false,
  actionLoading: false, // create/update/delete in-flight
  error: null
};

const FulfillmentOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create
    case 'CREATE_FULFILLMENT_ORDER_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_FULFILLMENT_ORDER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        orders: action.payload ? [action.payload, ...state.orders] : state.orders,
        error: null
      };
    case 'CREATE_FULFILLMENT_ORDER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // List
    case 'FETCH_FULFILLMENT_ORDERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_FULFILLMENT_ORDERS_SUCCESS':
      return {
        ...state,
        loading: false,
        orders: action.payload.orders || [],
        pagination: action.payload.pagination || null,
        error: null
      };
    case 'FETCH_FULFILLMENT_ORDERS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Detail (Phase 2B)
    case 'GET_FULFILLMENT_ORDER_REQUEST':
      return { ...state, loading: true, error: null };
    case 'GET_FULFILLMENT_ORDER_SUCCESS':
      return { ...state, loading: false, selectedOrder: action.payload, error: null };
    case 'GET_FULFILLMENT_ORDER_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Status update (Phase 2B stepper) — backend returns the full updated
    // order (with computed_color), so replace selectedOrder and the
    // matching row in `orders` wholesale rather than merging fields.
    case 'UPDATE_FULFILLMENT_STATUS_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_FULFILLMENT_STATUS_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        selectedOrder: action.payload || state.selectedOrder,
        orders: state.orders.map((o) => (action.payload && o.id === action.payload.id ? action.payload : o)),
        error: null
      };
    case 'UPDATE_FULFILLMENT_STATUS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Summary (Phase 2B admin dashboard cards)
    case 'FETCH_FULFILLMENT_SUMMARY_REQUEST':
      return { ...state, summaryLoading: true, error: null };
    case 'FETCH_FULFILLMENT_SUMMARY_SUCCESS':
      return { ...state, summaryLoading: false, summary: action.payload, error: null };
    case 'FETCH_FULFILLMENT_SUMMARY_FAILURE':
      return { ...state, summaryLoading: false, error: action.payload };

    // Delete (Phase 2B admin dashboard)
    case 'DELETE_FULFILLMENT_ORDER_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'DELETE_FULFILLMENT_ORDER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        orders: state.orders.filter((o) => o.id !== action.payload),
        error: null
      };
    case 'DELETE_FULFILLMENT_ORDER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default FulfillmentOrderReducer;
